window.RevaaCalculatorCore = {

  products: {

    trialKit: {
      name: 'The Iconic Trial Kit',
      price: 999
    },

    hipHugger: {
      name: 'Hip Hugger',
      price: 549
    },

    classicBoyshorts: {
      name: 'Classic Boyshorts',
      price: 999
    },

    seamfreeHipHugger: {
      name: 'Seamfree Hip Hugger',
      price: 899
    }

  },

  calculate(data) {

    const padsPerPeriod =
      Number(data.padsPerPeriod);

    const periods =
      Number(data.periods);

    const pieces =
      Number(data.pieces || 1);

    const pricePerPad =
      Number(data.pricePerPad || 12);

    const product =
      this.products[data.product];

    if (!product) {
      return null;
    }

    const disposableCost =
      padsPerPeriod *
      periods *
      pricePerPad;

    const revaaCost =
      product.price *
      pieces;

    const savings =
      Math.max(
        disposableCost - revaaCost,
        0
      );

    return {

      productName:
        product.name,

      disposableCost,

      revaaCost,

      savings,

      periods,

      pieces

    };

  }

};